import { useEffect, useState } from "react";
import { Effect } from "../../types";

export const useScrollPosition = (): number => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);
  useEffect((): Effect => {
    const updatePosition = (): void => {
      setScrollPosition(window.pageYOffset);
    }
    window.addEventListener("scroll", updatePosition);
    updatePosition();
    return (): void => window.removeEventListener("scroll", updatePosition);
  }, []);

  return scrollPosition;
};